import React from 'react';
import { EditableContextType } from './types';

// Create the context with a proper shape
export const EditableContext = React.createContext<EditableContextType>({
  form: null,
  editingRow: '',
  editingColumn: '',
});
